import { TreeDataItem } from "@myapp/modules/fwcore/models";
import { ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";



export class RequestPermissionTree extends RequestBasePageId {

  licenseId?: string | null;
  moduleIds?: string[] | null;
  hierarchyId?: string | null;

  authTypes?: string[] | null;
  authTypesExclude?: string[] | null;
  includeMembers?: boolean | null;
  includeHierarchies?: boolean | null;
  includeLabels?: boolean | null;
  cascadeLink?: boolean | null;
  active?: boolean | null;
  processFilter?: number | null;
}

export class ResponsePermissionTree extends ResponseBaseSet<TreeDataItem> {

}


